module.exports = __webpack_public_path__ + "65be4676a60c049fbc338f51914e8b0a.webm";